import { render } from "./Section1Features.vue?vue&type=template&id=1e15966d&scoped=true"
const script = {}

import "./Section1Features.vue?vue&type=style&index=0&id=1e15966d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e15966d"]])

export default __exports__